import React from "react";
import DevCard from "./AllBlocksDocsComponents/DevCard";
import GuideCard from "./AllBlocksDocsComponents/GuideCard";
import TokenCard from "./AllBlocksDocsComponents/TokenCard";
const AllBlocksDocs = () => {
    return (
        <>
            <div className="_doc_nft_wrapper">
                <div className="_doc_nft_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="_doc_nft_head">
                                    <h3 className="_doc_nft_head_txt">Allblocks Docs</h3>
                                    <p className="_doc_nft_head_para">The decentralized NFT
                                        marketplace. By the people, for the people.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <GuideCard/>
                            <TokenCard/>
                            <DevCard/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AllBlocksDocs;